import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const test: ContentBlock<"test"> = {
  id: makeId("test-estradiol"),
  kind: "test",
  tags: ["testing", "her", "pre-cycle", "during-cycle"],
  title: "Estradiol",
  subtitle: "Estradiol (E2) for ovarian activity and cycle timing",
  icon: "🩸",
  body: {
    testName: "Estradiol (E2)",
    category: "blood-marker",
    whatItMeasures:
      "Estradiol (E2) helps assess ovarian activity and uterine-lining growth; its meaning depends on cycle timing.",
    howItWorks:
      "A blood draw at any lab or clinic. It may be measured on cycle day 2-4 for baseline context and repeated during stimulation or transfer preparation. Fasting is usually not required unless it is bundled with other tests.",
    quickFacts: [
      { kind: "sample", value: "Blood" },
      { kind: "time", value: "5 min draw" },
      { kind: "pain", value: "Needle pinch" },
      { kind: "prep", value: "Timing depends on the protocol" },
      { kind: "results", value: "Same day to 2 business days" },
    ],
    turnaroundTime: "Same day to 2 business days",
    cycleDay:
      "Day 2-4 for baseline; repeated during stimulation or transfer preparation",
    markerTiming: [
      {
        marker: "Estradiol (E2)",
        timing: "Day 2-4 for baseline; repeated during stimulation",
        reason:
          "Baseline estradiol helps interpret FSH, while later values are read as a trend with follicle growth and protocol timing.",
      },
    ],
    atHome: false,
    clinicRequired: false,
    dataPoints: [makeId("dp-estradiol-level")],
    section: "cycle-monitoring",
  },
  sources: [
    {
      title: "ESHRE guideline: ovarian stimulation for IVF/ICSI",
      authors: "ESHRE Guideline Group on Ovarian Stimulation",
      journal: "Human Reproduction Open",
      year: 2020,
      url: "https://academic.oup.com/hropen/article/2020/2/hoaa009",
      evidenceLevel: "guideline",
    },
  ],
  readTimeMinutes: 3,
};

registerBlock(test);
